import ErrorTrackerServiceProvider from './Framework/ErrorTrackerServiceProvider';
const ErrorTracker = ErrorTrackerServiceProvider();

export default ErrorTracker;
